import { render, staticRenderFns } from "./AccordionItem.vue?vue&type=template&id=4c1a8f6c&"
import script from "./AccordionItem.vue?vue&type=script&lang=js&"
export * from "./AccordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c1a8f6c')) {
      api.createRecord('4c1a8f6c', component.options)
    } else {
      api.reload('4c1a8f6c', component.options)
    }
    module.hot.accept("./AccordionItem.vue?vue&type=template&id=4c1a8f6c&", function () {
      api.rerender('4c1a8f6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/Accordion/AccordionItem.vue"
export default component.exports